import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

/** 404 del Admin Web. */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="auth-shell">
      <Result
        status="404"
        title="404"
        subTitle="La página que buscas no existe."
        extra={
          <Button type="primary" onClick={() => navigate('/noc', { replace: true })}>
            Ir al NOC
          </Button>
        }
      />
    </div>
  );
}
